var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "check-list" },
    [
      _c(
        "Modal",
        {
          ref: "modal",
          attrs: {
            modalType: "large-modal",
            modalId: "checklist-" + +new Date(),
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-header", attrs: { solt: "modal-header" } },
            [
              _c("div", { staticClass: "emphasis" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "terms." +
                          _vm.regionName +
                          ".finalDocuments.submissionChecklist.title"
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "check-list__box",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("div", { staticClass: "check-list__subtilte emphasis" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "terms." +
                          _vm.regionName +
                          ".finalDocuments.submissionChecklist.subTitle"
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "last-update" }, [
                _c("div", { staticClass: "last-update__text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "terms." +
                            _vm.regionName +
                            ".finalDocuments.submissionChecklist.subTilteTips"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "check-list__content" },
                _vm._l(_vm.sections, function (section, index) {
                  return _c(
                    "div",
                    { key: section.type, staticClass: "check-list__section" },
                    [
                      section.type
                        ? _c(
                            "div",
                            { staticClass: "check-list__section-title" },
                            [
                              _vm._v(
                                _vm._s([index + 1, section.type].join(" "))
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(section.itemGroup, function (group) {
                        return _c(
                          "ol",
                          {
                            key: group.title,
                            staticClass: "check-list__group",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "check-list__group-title" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(group.title) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ol",
                              { staticClass: "check-list__section-items-box" },
                              _vm._l(group.content, function (item) {
                                return _c("li", {
                                  key: item,
                                  staticClass: "check-list__section-item",
                                  domProps: { innerHTML: _vm._s(item) },
                                })
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }